import React from 'react'
import classNames from 'classnames'
import { NameTag } from './NameTag'
import { DateTag } from './DateTag'
import { Label } from './Label'
import { getText, getFirstImage } from './oldContentHelper'
import fallbackImage from '../../images/falback-post-image.jpg' //TODO: change image
import { Link } from '../global'

import './posts.scss'

/**
 * Represents a post within your application.
 *
 * @param {object} props.post - The post data to display.
 * @param {string} props.size - The size of the post (optional, default is 'medium') sizes: small, medium, large.
 * @param {string} props.direction - The direction of the post layout (optional, only for small size, default is 'vertical'), directions: vertical, horizontal.
 * @param {boolean} props.useFalbackImg - Whether to use a fallback image if the post has no featured image (optional, default is `false`).
 *
 * @returns {JSX.Element} A React component rendering the post.
 */
export const Post = ({
  post,
  size = 'medium',
  direction = 'vertical',
  useFalbackImg = false,
}) => {
  let image = post.featuredImage?.node
  let content = post.postFlexContent?.subheader
  const title = post.postFlexContent?.customHeader || post.title
  const category = post.categories?.nodes[0]
  const isBlogg = category && category.slug === 'bloggar'
  const isBetongVarlden = category && category.id === 'dGVybToxMjk4NQ=='
  const isArkitektVarlden = category && category.id === 'dGVybToy'
  const tagSize = ['large', 'medium'].includes(size) ? 'large' : 'medium'
  const imagePosition = post.postFlexContent?.imagePosition
  const nameTagMobileColor = ['large', 'medium'].includes(size)
    ? 'white'
    : 'black'

  if (!content) {
    if (post.content) content = getText(post.content)
    if (!image) image = getFirstImage(post.content)
  }

  if (!image && useFalbackImg)
    image = {
      sourceUrl: fallbackImage,
      altText: 'Betong',
    }

  const linkClasses = classNames('post-container border', {
    'no-image': !image,
    [`${size}`]: ['large', 'medium'].includes(size),
    [`${size}-${direction}`]: !['large', 'medium'].includes(size),
  })

  const tagColor =
    size === 'medium' ||
    (image && direction === 'horizontal' && size === 'small')
      ? 'white-opacity'
      : 'black'

  return (
    post && (
      <Link to={`${post.uri}`} className={linkClasses}>
        <div className="gradient" />
        <div className="" />
        {image && (
          <img
            style={{ objectPosition: imagePosition }}
            src={image?.sourceUrl}
            alt={image?.altText}
          />
        )}
        <Label
          text={category?.name}
          article
          size={tagSize}
          backgroundColor={
            isBlogg
              ? 'orange'
              : isArkitektVarlden
                ? 'blue'
                : isBetongVarlden
                  ? 'green'
                  : 'gray'
          }
          textColor="white"
        />
        <div className="text-container">
          <h2>{title}</h2>
          <p
            dangerouslySetInnerHTML={{
              __html: (content && content[0]?.content) || content,
            }}
          />
          {/* TODO: change this element to the right one after acf updates */}
        </div>
        <div className="last-row">
          <NameTag
            author={post.author.node}
            color={tagColor}
            size={tagSize}
            ballColor={isBlogg ? 'orange' : 'green'}
            mobileColor={nameTagMobileColor}
          />
          <DateTag
            date={post.date}
            color={tagColor}
            size={tagSize}
            mobileColor={nameTagMobileColor}
          />
        </div>
      </Link>
    )
  )
}
